














































































import Vue from 'vue'
import dayjs from 'dayjs'
import { getImageUrl } from '@/utils/helper'
import { Activity } from '@/core/Activities'
import {
  Gender,
  ProgramLevel,
  programLevelLabels,
  programGenderLabels,
} from '@/core/Programs'

export default Vue.extend({
  filters: {
    toFormattedDate(date: string): string {
      return dayjs(date).format('M月D日(dd) HH:mm')
    },
  },
  props: {
    programName: {
      type: String,
      required: true,
    },
    facilityName: {
      type: String,
      required: true,
    },
    instructorName: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      required: true,
    },
    startAt: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      required: true,
    },
    point: {
      type: Number,
      required: true,
    },
    activities: {
      type: Array as () => Activity[],
      default: [],
    },
    level: {
      type: Number as () => ProgramLevel,
      default: ProgramLevel.ENTRY,
    },
    sexLimitation: {
      type: String as () => Gender,
      default: Gender.NONE,
    },
  },
  computed: {
    levelLabel(): string {
      return programLevelLabels[this.level]
    },
    sexLimitationLabel(): string {
      return programGenderLabels[this.sexLimitation]
    },
  },
  methods: {
    getImageUrl: getImageUrl,
  },
})
